import { asyncLoadRouter } from '@router/helper'
import organizations from '@router/paths/manager/accounts/organizations'
import roles from '@router/paths/manager/accounts/roles'

const accounts = [
  {
    path: 'accounts',
    component: asyncLoadRouter('manager/Accounts'),
    meta: {
      authorize: ['admin', 'manager'],
      breadcrumb: (i18n) => [
        { text: i18n.t('activerecord.models.account.other'), to: { name: 'manager-accounts' } },
      ],
    },
    children: [
      {
        path: '',
        name: 'manager-accounts',
        component: asyncLoadRouter('manager/accounts/List'),
        meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.list') }] },
      },
      {
        path: ':account_id([A-Za-z\\d]{22})',
        name: 'manager-accounts-show',
        component: asyncLoadRouter('manager/accounts/Show'),
        redirect: (to) => {
          return {
            name: 'manager-accounts-edit',
            params: { account_id: to.params.account_id },
          }
        },
        meta: {
          breadcrumb: (i18n, params) => [
            {
              text: `ID ${params.account_id}`,
              to: {
                name: 'manager-accounts-edit',
                params: { account_id: params.account_id },
              },
            },
          ],
        },
        children: [
          {
            path: 'edit',
            name: 'manager-accounts-edit',
            component: asyncLoadRouter('manager/accounts/Form'),
            meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
            props: { action: 'update' },
          },
          {
            path: 'profile',
            component: asyncLoadRouter('manager/accounts/Profile'),
            redirect: (to) => {
              return {
                name: 'manager-accounts-profile-edit',
                params: { account_id: to.params.account_id },
              }
            },
            meta: {
              breadcrumb: (i18n, params) => [
                {
                  text: i18n.t('activerecord.models.account/profile.one'),
                  to: {
                    name: 'manager-accounts-profile-edit',
                    params: { account_id: params.account_id },
                  },
                },
              ],
            },
            children: [
              {
                path: 'edit',
                name: 'manager-accounts-profile-edit',
                component: asyncLoadRouter('manager/accounts/profile/Form'),
                meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
                props: { action: 'update' },
              },
            ],
          },
          {
            path: 'contact',
            component: asyncLoadRouter('manager/accounts/Contact'),
            redirect: (to) => {
              return {
                name: 'manager-accounts-contact-edit',
                params: { account_id: to.params.account_id },
              }
            },
            meta: {
              breadcrumb: (i18n, params) => [
                {
                  text: i18n.t('activerecord.models.contact.one'),
                  to: {
                    name: 'manager-accounts-contact-edit',
                    params: { account_id: params.account_id },
                  },
                },
              ],
            },
            children: [
              {
                path: 'edit',
                name: 'manager-accounts-contact-edit',
                component: asyncLoadRouter('manager/accounts/contact/Form'),
                meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
                props: { action: 'update' },
              },
            ],
          },
          {
            path: 'address',
            component: asyncLoadRouter('manager/accounts/Address'),
            redirect: (to) => {
              return {
                name: 'manager-accounts-address-edit',
                params: { account_id: to.params.account_id },
              }
            },
            meta: {
              breadcrumb: (i18n, params) => [
                {
                  text: i18n.t('activerecord.models.address.one'),
                  to: {
                    name: 'manager-accounts-address-edit',
                    params: { account_id: params.account_id },
                  },
                },
              ],
            },
            children: [
              {
                path: 'edit',
                name: 'manager-accounts-address-edit',
                component: asyncLoadRouter('manager/accounts/address/Form'),
                meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
                props: { action: 'update' },
              },
            ],
          },
          ...organizations,
          ...roles,
        ],
      },
    ],
  },
]

export default accounts
